module.exports = __webpack_public_path__ + "img/284.6d23506b.jpg";